import { RateProviderDetails } from './RateProviderDetails';

export class P44RateProviderDetails implements RateProviderDetails {
  code?: string;
  accounts?: string[] = [];

  constructor(opts?: Partial<P44RateProviderDetails>) {
    if (opts?.code != null) {
      this.code = opts.code;
    }
    if (opts?.accounts != null) {
      this.accounts = [...opts.accounts];
    }
  }
}
